module.exports = __webpack_public_path__ + "static/media/122.db9a9718.jpg";